module.exports = __webpack_public_path__ + "static/media/ava4.b1b80fc2.svg";